module.exports = __webpack_public_path__ + "static/img/20160921-2.1a728d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20160921-2.jpg
// module id = UPHn
// module chunks = 0